import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { LeagueListLayer } from '../components/GameLeague/LeagueListLayer'

export const LeagueListPage = () => {
  return (
   <MasterLayout>
    <LeagueListLayer/>
   </MasterLayout>
  )
}
